import { getInventoriesforIds } from "@Pages/Search/components/SimilarProperties/helper";
import axios from "axios";
import Config from "config";
import getCookie from "helpers/getCookie";
import urljoin from "helpers/urljoin";

export const getPreviouslyViewedInventories = async (
  canonical_names: any,
  isWhitelabel?: boolean,
  partner_id?: any,
  user_currency?: string,
  lang?: string,
) => {
  try {
    const url = urljoin(Config.API_URL, "api/v1/inventories");
    const res: any = await axios.get(url, {
      params: {
        only: isWhitelabel
          ? "id,status,images,name,canonical_name,location,pricing,tags,features,is_whitelabel_inventory,whitelabel_partner_ids"
          : "id,status,images,name,canonical_name,location,pricing,tags,features",
        methods:
          "active_children_count,location_coordinates,reviews_rating,reviews_count,meta_short,top_meta_distances,region_parent_city_canonical,amber_sales",
        limit: "10",
        bypass_limit: true,
        canonical_names: canonical_names.join(","),
        ...(isWhitelabel && { get_all_whitelabel_partner_inventories: partner_id }),
        ...(isWhitelabel && { exclude_whitelabel_inventories: false }),
        ...(user_currency ? { user_currency } : {}),
        ...(lang ? { lang } : {}),
        use_java_api: true,
      },
      headers: { "X-Use-Java-Api": "true" },
    });
    let result: any = [[], "err"];
    if (res.data?.data) {
      result = res.data.data;
    }
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getShortlistedInventories = async (userCurrency = "", lang = "") => {
  const url = urljoin(Config.API_URL, "api/v0/auth/users/inventories_shortlists");
  const res: any = await axios.get(url, {
    params: {
      include: "inventory",
      p: 1,
      methods: "inventory_offer_count,inventory_children_count,reviews_count,reviews_rating",
      limit: "10",
      bypass_limit: true,
      sort_key: "created",
      sort_order: "desc",
      type: "list",
      ...(userCurrency ? { user_currency: userCurrency } : {}),
      ...(lang ? { lang } : {}),
    },

    withCredentials: true,
  });
  let result = [[], "err"];
  if (res.data?.data) {
    result = res.data.data;
  }
  return result;
};

export const getEnquiredInventories = async (
  isUserLoggedIn: boolean,
  isWhitelabel?: boolean,
  userCurrency = "",
  lang = "",
) => {
  const isCookiePresent = getCookie("user_flow_token");
  if (!isCookiePresent && !isUserLoggedIn) {
    return {
      result: [],
    };
  }
  const url = urljoin(Config.API_URL, "api/v0/user_flow/history");
  const res: any = await axios.get(url, {
    withCredentials: true,
    params: {
      methods: "redirection_urls",
    },
  });

  if (Object.keys(res.data.data).length === 0) {
    return {
      result: [],
    };
  }

  const inventoryIds = [
    ...res.data.data.payment_completed?.reverse(),
    ...res.data.data.payment_initiated?.reverse(),
    ...res.data.data.book_form_completed?.reverse(),
    ...res.data.data.book_form_initiated?.reverse(),
    ...res.data.data.enquired?.reverse(),
  ];
  if (!inventoryIds.length) {
    return {
      result: [],
    };
  }
  const inventoryRes = await getInventoriesforIds(inventoryIds, {
    params: {
      limit: "10",
      bypass_limit: true,
      methods: "top_meta_distances,reviews_rating,reviews_count,meta_short,amber_sales",
      ...(userCurrency ? { user_currency: userCurrency } : {}),
      ...(lang ? { lang } : {}),
      ...(isWhitelabel && { exclude_whitelabel_inventories: false }),
    },
  });
  const inventories = inventoryRes.data.data;
  // priority order to show inventories
  const priority: any = {
    payment_completed: 0,
    payment_initiated: 1,
    book_form_completed: 2,
    book_form_initiated: 3,
    enquired: 4,
  };
  // Comparator function
  const compareByPriority = (a: any, b: any) =>
    priority[a.enquiryStatus] - priority[b.enquiryStatus];
  inventories.result.forEach((inv: any, i: number) => {
    if (res.data.data.payment_completed.includes(inv.id)) {
      inventories.result[i]["enquiryStatus"] = "payment_completed";
    } else if (res.data.data.payment_initiated.includes(inv.id)) {
      inventories.result[i]["enquiryStatus"] = "payment_initiated";
    } else if (res.data.data.book_form_completed.includes(inv.id)) {
      inventories.result[i]["enquiryStatus"] = "book_form_completed";
    } else if (res.data.data.book_form_initiated.includes(inv.id)) {
      inventories.result[i]["enquiryStatus"] = "book_form_initiated";
    } else if (res.data.data.enquired.includes(inv.id)) {
      inventories.result[i]["enquiryStatus"] = "enquired";
    }
  });
  inventories.result.sort(compareByPriority);

  return inventories;
};
